<template>
    <div class="hold">
    <h3 class="title">
      You need a Referee.
      <small class="form-text text-muted">This should be a person willing to testify  about your character or ability, prefferably a former superior, colleague, teacher or mentor. Note that your referee should not be biased, for example your referee should not be a friend or  relative.</small>
      <svg v-if="$auth.user().progress.referral" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 352.62 352.62" style="enable-background:new 0 0 352.62 352.62;" xml:space="preserve"><g><g><path d="M337.222,22.952c-15.912-8.568-33.66,7.956-44.064,17.748c-23.867,23.256-44.063,50.184-66.708,74.664   c-25.092,26.928-48.348,53.856-74.052,80.173c-14.688,14.688-30.6,30.6-40.392,48.96c-22.032-21.421-41.004-44.677-65.484-63.648   c-17.748-13.464-47.124-23.256-46.512,9.18c1.224,42.229,38.556,87.517,66.096,116.28c11.628,12.24,26.928,25.092,44.676,25.704   c21.42,1.224,43.452-24.48,56.304-38.556c22.645-24.48,41.005-52.021,61.812-77.112c26.928-33.048,54.468-65.485,80.784-99.145   C326.206,96.392,378.226,44.983,337.222,22.952z M26.937,187.581c-0.612,0-1.224,0-2.448,0.611   c-2.448-0.611-4.284-1.224-6.732-2.448l0,0C19.593,184.52,22.653,185.132,26.937,187.581z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#639440"/></g></g></svg>
    </h3>
    <div class="panel-body elevated py-6">
      <div class="row" style="margin: 0;">
        <div class="col-12">
          <div class="form-group">
            <label>Referee Name</label>
            <input type="text" v-validate.disable="'required'" name="name" v-model="name" :disabled="!editable" placeholder="Referee Name" :class="{'form-control': true, 'is-invalid': errors.has('name') }">
          </div>
          <div class="form-group">
            <label>Referee Phone</label>
            <input type="text" v-validate.disable="'required'" name="phone" v-model="phone" :disabled="!editable" placeholder="Referee Phone" :class="{'form-control': true, 'is-invalid': errors.has('phone') }">
          </div>
          <div class="form-group">
            <label>Referee Email</label>
            <input type="text" v-validate.disable="'required|email'" name="email" v-model="email" :disabled="!editable" placeholder="Referee Email" :class="{'form-control': true, 'is-invalid': errors.has('email') }">
          </div>
          <div class="form-group">
            <label>Referee Address</label>
            <input type="text" v-validate.disable="'required'" name="address" v-model="address" :disabled="!editable" placeholder="Referee Address" :class="{'form-control': true, 'is-invalid': errors.has('address') }">
          </div>
          <div class="form-group">
            <label>Relationship to you</label>
            <input type="text" v-validate.disable="'required'" name="relationship" v-model="relationship" :disabled="!editable" placeholder="Relationship to you" :class="{'form-control': true, 'is-invalid': errors.has('relationship') }">
          </div>
          <div class="form-group">
            <label>Referee Occupation</label>
            <input type="text" v-validate.disable="'required'" name="occupation" v-model="occupation" :disabled="!editable" placeholder="Referee Occupation" :class="{'form-control': true, 'is-invalid': errors.has('occupation') }">
          </div>
          <div class="form-group">
            <button class="btn btn-success submit-button mx ignore right"  v-if="editable" :disabled="submitting" @click="submit">
              <span>Submit</span>
              <i class="fa fa-spin fa-circle-o-notch" v-if="submitting"></i>
            </button>
            <button v-else class="btn btn-success submit-button mx ignore right" @click="makeEditable">
              <span>Update Referee</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert';
import Spinner from '@/components/Preloaders/Spinner';

export default {
  name: 'referral-verification',
  components: { Spinner },
  data() {
    return {
      name: this.$auth.user().referral && this.$auth.user().referral.name,
      phone: this.$auth.user().referral && this.$auth.user().referral.phone,
      email: this.$auth.user().referral && this.$auth.user().referral.email,
      address: this.$auth.user().referral && this.$auth.user().referral.address,
      relationship: this.$auth.user().referral && this.$auth.user().referral.relationship,
      occupation: this.$auth.user().referral && this.$auth.user().referral.occupation,
      submitting: false,
      hasError: false,
      editable: !this.$auth.user().progress.referral,
      error: {},
    };
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.submitReferral();
        } else {
          swal(
            'Sorry',
            'There are some errors on the form. Please correct them and try again',
            'error'
          );
        }
      });
    },
    async shouldUnVerify() {
      if (this.$auth.user().verified) {
        const proceed = await swal({
          title: 'Are you Sure?',
          text: 'Please note that this action would unverify you, and you\'ll have to wait to be re-verified.',
          icon: 'warning',
          buttons: ['Don\'t bother', 'Continue >>>'],
        });
        return proceed;
      } else {
        return true;
      }
    },
    async submitReferral() {
      const canProceed = await this.shouldUnVerify();
      if (! canProceed) {
        return null;
      }
      this.submitting = true;
      return axios.post(`${BASE_API}/v1/tutor/profile/referrals`, this.buildData())
        .then((response) => {
          this.submitting = false;
          swal(
            'Success',
            'Your Referee information was updated successfully.',
            'success'
          );
          this.$auth.fetch();
          this.editable = false;
        })
        .catch((response) => {
          this.submitting = false;
          swal(
            'Sorry',
            'There are some errors on the form. Please correct them and try again',
            'error'
          );
        });
    },
    buildData() {
      return {
        name: this.name,
        phone: this.phone,
        email: this.email,
        address: this.address,
        relationship: this.relationship,
        occupation: this.occupation,
      };
    },
    makeEditable() {
      this.editable = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.hold {
  margin: 15px 0;
}
.panel-body {
  padding: 10px !important;
}
.elevated {
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(150,150,150,0.14), 0 3px 1px -2px rgba(150,150,150,0.12), 0 1px 5px 0 rgba(150,150,150,0.2);
}
.submit-button {
  width: 130px;
  height: 38px;
  line-height: 38px;
  padding: 0 10px;
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
  vertical-align: middle;
  box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14), 0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
  // float: right;
  &:focus {
    outline: 0 !important;
    box-shadow: none !important;
    &:active {box-shadow: none !important;}
  }
}
.error-text {
  font-size: 11px;
  color: #FE595F;
  margin-left: 5px;
}
.success-text {
  font-size: 11px;
  color: #639440;
  margin-left: 5px;
}
.title {
  svg {
    float: right;
    height: 18px;
    width: 18px;
    margin: 0 15px;
  }
}
.bold {font-weight: 600; margin: 10px 0;}
.py-6 {padding: 35px 0 !important;}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Verification/Referral.vue